import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function MonthlySubscriptionDetails() {
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 1.5, minWidth: { sm: '330px' } }}>
      <Typography variant="body2">
        {t('checkout.monthly.description')}
      </Typography>
    </Box>
  );
}
